/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const bookingFrontdeskProviderSettings = sqliteTable('booking_frontdesk_provider_settings', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  provider_id: text('provider_id'),
  enabled: integer('enabled'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
